import axios from 'axios'
import { API } from '../Config'

export const givePrice = async (userName, city) => {
    try {
        const response = await axios({
            method: 'POST',
            url: `${API}/user/givePrice`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                userName,
                city
            }
        })

        return response
    } catch (err) {
        throw err.response
    }
}

export const calculatePrice = async (userName, city) => {
    try {
        const response = await axios({
            method: 'POST',
            url: `${API}/user/calculator`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                userName,
                city
            }
        })

        return response
    } catch (err) {
        throw err.response
    }
}

export const updateEntries = async (id, data) => {
    try {
        const response = await axios({
            method: 'POST',
            url: `${API}/user/updateEntry`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                id,
                data
            }
        })

        return response
    } catch (err) {
        throw err.response
    }
}

export const saveSurvey = async (id, data) => {
    try {
        const response = await axios({
            method: 'POST',
            url: `${API}/user/saveSurvey`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                id,
                data
            }
        })
        return response
    } catch (err) {
        throw err
    }
}

export const downloadCertificate = async (id, data) => {
    try {
        const response = await axios({
            method: 'POST',
            url: `${API}/user/download`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                id,
                data
            }
        })

        return response
    } catch (err) {
        throw err.response
    }
}
